import React from 'react';
import Map from './Map';


class MapContainer extends React.Component { 
    render() {
      const { markers, zoom, mapCenter, single } = this.props;
      if (!markers) return null; 
       
      const containerStyle = { height: `${single ? '400px' : '500px'}`, width: '100%' };
      return (
        <Map
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyAS0MMdoCXhd9CSJr3dSJXyhlJxBX3Xkts"
          loadingElement={<div style={{ height: `100%` }} />}
          single={single}
          mapCenter={mapCenter}
          markers={markers}
          zoom={zoom}
          containerElement={ <div style={containerStyle} /> }
          mapElement={ <div style={{ height: `100%` }} /> }
        />
      );
    } 
}


export default MapContainer; 